import { gql } from '@apollo/client'

import { CompanyFragment } from './company.fragment'
import { TradeFragment } from './trade.fragment'
import { ProjectFilePositionsFragment } from './project-file-positions.fragment'
import { ProjectFileFragment } from './project.fragment'

export const TaskFragment = gql`
  fragment TaskFragment on Task {
    id
    idNumber
    startAt
    endAt
    startRowByZone
    startRowByCompany
    startRowByTrade
    createdDate
    name
    description
    requiredDuration
    duration
    workforce
    zoneId
    status
    progress
    tradeKey
    color
    trade {
      ...TradeFragment
    }
    companyId
    company {
      ...CompanyFragment
    }
    projectFileId
    projectFile {
      ...ProjectFileFragment
    }
    projectFilePositions {
      ...ProjectFilePositionsFragment
    }
  }
  ${CompanyFragment}
  ${TradeFragment}
  ${ProjectFileFragment}
  ${ProjectFilePositionsFragment}
`

export const TaskFragmentWithoutProjectFileFragment = gql`
  fragment TaskFragmentWithoutProjectFileFragment on Task {
    id
    idNumber
    startAt
    endAt
    startRowByZone
    startRowByCompany
    startRowByTrade
    createdDate
    name
    description
    requiredDuration
    duration
    workforce
    zoneId
    status
    progress
    tradeKey
    color
    trade {
      ...TradeFragment
    }
    companyId
    company {
      ...CompanyFragment
    }
    projectFilePositions {
      ...ProjectFilePositionsFragment
    }
  }
  ${CompanyFragment}
  ${TradeFragment}
  ${ProjectFilePositionsFragment}
`
